var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"cn-treeview-wrapper space-y-6",class:{
    'cn-treeview-wrapper--disabled': _vm.disabled,
  }},[_c(_setup.Treeselect,{staticClass:"cn-treeview",attrs:{"multiple":true,"options":_vm.items,"always-open":"","normalizer":_setup.normalizer,"default-expand-level":Infinity,"disable-branch-nodes":_vm.disableBranchNodes,"searchable":false,"z-index":1},model:{value:(_setup.vModel),callback:function ($$v) {_setup.vModel=$$v},expression:"vModel"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }